<template>
  <div class="container">
    <div class="nban pc">
      <img src="@/view/images/y22-2.jpg">
      <div class="nbana">
        <p class="on">
          <router-link to="/solution2?navaa=1">蜂享优印解决方案</router-link>
        </p>
        <p>
          <router-link to="/solution1?navaa=1">印刷数字化工厂解决方案</router-link>
        </p>
        <p>
          <router-link to="/solution?navaa=1">印刷管家服务解决方案</router-link>
        </p>
        <div class="clearfix"></div>
      </div>
    </div>
    <!-- <div class="mbx pc">
      <div class="commenMy">
        <p>位置：<a href="#">首页</a> &gt; <a href="#">解决方案</a></p>
      </div>
    </div> -->
    <!--印刷管家服务解决方案-->
    <div class="neiy">

      <div class="commenMy" >
        <div class="nbana mob">
          <p class="on">
            <router-link to="/solution2?navaa=1">蜂享优印解决方案</router-link>
          </p>
          <p>
            <router-link to="/solution1?navaa=1"
            >印刷数字化工厂解决方案</router-link
            >
          </p>
          <p class="">
            <router-link to="/solution?navaa=1"
            >印刷管家服务解决方案</router-link
            >
          </p>
          <div class="clearfix"></div>
        </div>
        <div>
          <img style="display: inline-block" src="@/view/images/icon-1.png">
          <div class="title-box">蜂享优印平台</div>
        </div>
        <div style="margin-left: 25px;">
          <div style="font-size: 14px;line-height: 32px;margin-top: 15px;margin-bottom: 15px">
            隶属于青岛优选文创科技有限公司，由青岛报业传媒集团和印工社（青岛）数字科技有限公司共同创办，旨在围绕“青岛品牌升级”战略，依托青岛报业传媒资源优势和印刷工业互联网新技术，打造从品牌策划、品牌宣传到包装设计、印刷交付的专业服务平台，服务“青岛品牌”立足青岛，走向全国，走向世界！
          </div>
          <div style="margin-bottom: 40px">
            <img src="@/view/images/banner-img.png">
          </div>
        </div>
      </div>
      <div style="background-color: #f7f7f7;margin-bottom: 35px">
        <div class="commenMy banner-box">
          <div style="margin-bottom: 15px">
            <img style="display: inline-block" src="@/view/images/icon-1.png">
            <div class="title-box">整合优势资源 构建品牌成长全产业链</div>
          </div>
          <div style="padding-left: 30px">
            <img class="img-center" src="@/view/images/icon-3.png">
            <div class="text-center">营销与活动策划平台</div>
          </div>
          <div style="padding-left: 50px;margin-bottom: 40px;font-size: 12px">
            青岛报业传媒集团“营销与活动策划平台”，助力推广青岛本土品牌，提升青岛品牌价值。
          </div>
          <div style="margin-left: 125px;margin-bottom: 60px">
            <img style="width: 300px" src="@/view/images/img-icon.png">
          </div>
          <div style="padding-left: 30px;margin-bottom: 15px;">
            <img class="img-center" src="@/view/images/icon-3.png">
            <div class="text-center">数字化印刷全流程解决方案</div>
          </div>
          <div style="padding-left: 50px;margin-bottom: 40px;display: flex;width: 600px;justify-content: space-between;align-items: center;">
            <img src="@/view/images/yin-icon.png">
            <img src="@/view/images/icon-2.png">
            <span style="font-size: 18px;color: #3A80BE">值得您信赖的印刷管家！</span>
          </div>
          <div style="padding-left: 50px;">
            <div style="font-size: 18px;font-weight: bold;margin-bottom: 15px">
              印工社以专业软件开发为核心，提供数字化印刷全流程解决方案
            </div>
            <div style="line-height: 24px;font-size: 12px">
              印刷管家服务，通过建立印前、印刷全流程的色彩管理体系，重点解决色差问题，让印刷机变身高级复印机。通过色彩管理体系建立、标准化作业培训、印刷机状态维护、质量评测方法建立、印刷管家服务APP及线上线下的管家服务技术支持，提升色彩管理和标准化作业水平。
            </div>
          </div>
        </div>
      </div>
      <div class="commenMy" >
        <div style="background-color: #f7f7f7; color: #F08D23;padding: 20px ;line-height: 24px;margin-bottom: 30px;font-size: 12px;margin-left: 30px">
          青岛优选“蜂享优印”平台采用创新技术，帮助品牌商、设计师等多方资源在同一平台高效沟通，大幅缩短产品包装的 开发周期，并确保设计方案在打样、印前制作和印刷过程中颜色准确一致，真正做到产品包装有创意、能落地，实现高效率、高质量的交付。
        </div>
        <div>
          <img style="display: inline-block" src="@/view/images/icon-1.png">
          <div class="title-box">高效设计服务</div>
        </div>
        <div style="margin: 15px 30px 20px;font-size: 16px">
          缩短产品开发周期
        </div>
        <div style="margin: 15px 0 25px 30px">
          <div style="background-color: #f7f7f7;position: relative;top: 17px;border: 1px solid #f7f7f7;margin-left: 145px"></div>
          <img src="@/view/images/icon-4.png" style="z-index: 99">
        </div>
        <div style="margin: 15px 0 25px 30px; font-size: 12px">
          平面设计环节实现品牌方和设计师在同一平台进行色彩远程预览，实时确认色彩，确保产品包装从设计、修改、定稿到输出效果始终如一，无需现场打样确认，沟通效率高，极大缩短设计开发周期。
        </div>
        <div style="margin: 15px 0 25px 30px">
          <div style="background-color: #f7f7f7;position: relative;top: 17px;border: 1px solid #f7f7f7;margin-right: 205px"></div>
          <img src="@/view/images/icon-5.png" style="z-index: 99;float: right;margin-bottom: 10px">
        </div>
        <div style="margin: 15px 0 25px 30px;display: flex;width: 1170px">
          <div style="width: 619px;">
            <div style="display: inline-block;text-align: center;margin-right: 20px;margin-bottom: 15px">
              <img style="display: inline-block" src="@/view/images/icon-6.png">
              <div>1000+盒型库</div>
            </div>
            <div style="display: inline-block;text-align: center;">
              <img style="display: inline-block" src="@/view/images/icon-8.png">
              <div>智能结构设计</div>
            </div>
            <div style="display: inline-block;text-align: center;margin-right: 20px;margin-bottom: 15px">
              <img style="display: inline-block" src="@/view/images/icon-9.png">
              <div>一分钟3D效果图</div>
            </div>
            <div style="display: inline-block;text-align: center;">
              <img style="display: inline-block" src="@/view/images/icon-10.png">
              <div>盒型研发设计</div>
            </div>
          </div>
          <div>
            <div style="height: 110px;">
              <div style="color: #F08D23;font-size: 18px;font-weight: bold;margin-top: 27px;margin-bottom: 15px">快速实现盒型结构3D效果预览、在线打样</div>
              <div style="font-size: 16px;font-weight: bold;color:#040000;margin-bottom: 10px">
                智能盒型结构设计云服务：
              </div>
              <div style="font-size: 14px;color: #595757">盒型设计环节快速实现海量盒型结构3D效果预览与在线打样，极大缩短设计开发周期。</div>
            </div>
            <div style="height: 70px">
              <div style="font-size: 16px;font-weight: bold;color:#040000;margin-bottom: 10px;margin-top: 80px">特殊盒型定制开发服务：</div>
              <div style="font-size: 14px;color: #595757">对于智能盒型库之外的特殊盒型结构，同步支持结构设计定制开发、3D效果输出与分享。</div>
            </div>
          </div>
        </div>
        <div style="margin: 15px 0 25px 30px">
          <div style="background-color: #f7f7f7;position: relative;top: 17px;border: 1px solid #f7f7f7;margin-left: 145px"></div>
          <img src="@/view/images/icon-7.png" style="z-index: 99">
        </div>
        <div style="margin: 15px 0 35px 30px">
          <div style="color: #F08D23;font-size: 18px;font-weight: bold;margin-top: 27px;margin-bottom: 15px">快速打样沟通&色彩一致性呈现</div>
          <div style="display: flex">
            <div style="width: 53%">
              <div style="font-size: 16px;font-weight: bold;color:#040000;margin-bottom: 15px">1）快速打样沟通：</div>
              <div style="width: 85%;line-height: 24px;color:#595757;font-size: 12px">多方（品牌商/设计师/打样中心/印刷厂）在同一平台对包装印刷品的平面&结构设计、颜色&工艺&材料进行快速沟通和核对，实现精准高效打样确认。</div>
            </div>
            <div>
              <div style="font-size: 16px;font-weight: bold;color:#040000;margin-bottom: 15px;">2）打样色彩符合印刷规范：</div>
              <div style="line-height: 24px;color:#595757;font-size: 12px">包装设计方案最终还需要印刷落地！线下打样中心确保打样符合印刷规范。</div>
            </div>
          </div>
        </div>
      </div>
      <div style="background-color: #f7f7f7;margin-bottom: 35px">
        <div class="commenMy banner-box">
          <div style="margin-bottom: 15px">
            <img style="display: inline-block" src="@/view/images/icon-1.png">
            <div class="title-box">高质量印刷交付</div>
          </div>
          <div style="padding-left: 30px">
            <div style="display: inline-block;font-size: 17px;font-weight:bold;padding-bottom: 10px;">助力产品包装精准落地</div>
          </div>
          <div style="padding-left: 30px;margin-bottom: 40px;font-size: 12px">
            蜂享优印通过数字化的印刷新技术，解决包装设计与印刷色彩落差大的痛点，真正做到所见即所得。为中小品牌商的所有色彩提供低成本、高效率、高质量的落地交互呈现方案。
          </div>
          <div style="padding-left: 30px">
            <div style="display:inline-block;margin: 0 10px 10px 0">
              <div style="width: 570px;display: flex;align-items: center;background-color: #eeeeef">
                <img style="display:inline-block;" src="@/view/images/icon-img1.png">
                <div style="display:inline-block;margin-left: 40px">
                  <div style="border-bottom: 3px solid #EF8624;width: 40px;margin-bottom: 20px"></div>
                  <div style="color: #F08D23;font-size: 18px;font-weight: bold;margin-bottom: 20px">蜂享专色管理系统</div>
                  <div style="color:#595757; font-size: 14px;line-height: 24px">确保整个供应链精准<br>传递颜色数据</div>
                </div>
              </div>
            </div>

            <div style="display:inline-block;background-color: #eeeeef;margin: 0 10px 10px 0">
              <div style="width: 570px;display: flex;align-items: center;">
                <img style="display:inline-block;" src="@/view/images/icon-img2.png">
                <div style="display:inline-block;margin-left: 40px">
                  <div style="border-bottom: 3px solid #EF8624;width: 40px;margin-bottom: 20px"></div>
                  <div style="color: #F08D23;font-size: 18px;font-weight: bold;margin-bottom: 20px">蜂享专色配墨中心</div>
                  <div style="color:#595757; font-size: 14px;line-height: 24px">提供配方输出和监理服务<br/>支持专色油墨配制&配送</div>
                </div>
              </div>
            </div>
            <div style="display:inline-block;margin: 0 10px 10px 0">
              <div style="width: 570px;display: flex;align-items: center;background-color: #eeeeef">
                <img style="display:inline-block;" src="@/view/images/icon-img3.png">
                <div style="display:inline-block;margin-left: 40px">
                  <div style="border-bottom: 3px solid #EF8624;width: 40px;margin-bottom: 20px"></div>
                  <div style="color: #F08D23;font-size: 18px;font-weight: bold;margin-bottom: 20px">质量数字化管控</div>
                  <div style="color:#595757; font-size: 14px;line-height: 24px">印刷机变身高级复印机</div>
                </div>
              </div>
            </div>
            <div style="display:inline-block;background-color: #eeeeef;margin: 0 10px 10px 0">
              <div style="width: 570px;display: flex;align-items: center;background-color: #eeeeef">
                <img style="display:inline-block;" src="@/view/images/icon-img4.png">
                <div style="display:inline-block;margin-left: 75px">
                  <img src="@/view/images/icon-2-1.png">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <coun-sel></coun-sel>

  </div>
</template>
<script>
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?0fb0c350f1482064e25902f9db8dec76";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
</script>
<script>
import $ from 'jquery'; // 在需要使用的页面中
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import CounSel from '@/components/counsel';

export default {
  name: 'solutionName',
  components: {
    CounSel,
  },
  data() {
    return {
      content: '您的需求',
      mobile: '您的联系方式',
      gongsi: '您的公司',
    };
  },
  methods: {
    init() {

    },
    arrowClick(val) {
      if (val === 'right') {
        this.$refs.fa1show.next();
      } else {
        this.$refs.fa1show.prev();
      }
    },
  },
  mounted() {
    new Swiper('#swiper_fa1', {
      loop: true,
      slidesPerView: 1.7,
      spaceBetween: 20,
      centeredSlides: true,
    });
    new Swiper('#swiper_fa2', {
      loop: true,
      slidesPerView: 1.7,
      spaceBetween: 20,
      centeredSlides: true,
    });
    new Swiper('#swiper_fa3', {
      loop: true,
      slidesPerView: 1.7,
      spaceBetween: 20,
      centeredSlides: true,
    });
  },
  created() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>

<style scoped>
  .fa1dc{
    width: 31%;
    margin: 0 1.1%;
  }
  .fa1da_an{
    margin-top: 20px;
  }
  .pc .bannericon {
    width: 1600px;
  }

  .pc .bka_a {
    width: 50%;
  }
  .fa1fb{
    display: block !important;
  }
</style>
<style>
  .solushow .el-carousel__indicators--horizontal {
    width: 100% !important;
    position: absolute !important;
    bottom: 0% !important;
    left: 0 !important;
    transform: translateX(0) !important;
    z-index: 99 !important;
    text-align: center;
  }

  .solushow .el-carousel__button {
    cursor: pointer;
    width: 7px;
    height: 7px;
    margin: 0 2.5px;
    float: left;
    position: relative;
    transition: all ease 0 .35s;
    background-color: #1f232a;
    border-radius: 50%;
    opacity: 1;
    transition: all ease 0.35s;
  }

  .solushow .el-carousel__indicator.is-active button {
    background-color: #f6b415;
    width: 30px;
    border-radius: 20px;
  }
  .title-box{
    display: inline-block;color: #F08D23;font-size: 25px;font-weight:bold;padding-bottom: 10px;border-bottom: 1px solid #F08D23
  }
  .banner-box{
    /*width: 1200px; */
    padding-top: 30px;padding-bottom: 30px
  }
  .img-center{
    display: inline-block;width: 20px;vertical-align: sub;
  }
  .text-center{
    display: inline-block;color: #F08D23;font-size: 17px;font-weight:bold;padding-bottom: 10px;
  }
  .commenMy{
    width: 1200px !important;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/solution2.vue